export default "__VITE_ASSET__BT3xDfkR__"